import { render, staticRenderFns } from "./HomeExaminationInfo.vue?vue&type=template&id=5e4fb136&scoped=true&"
import script from "./HomeExaminationInfo.vue?vue&type=script&lang=js&"
export * from "./HomeExaminationInfo.vue?vue&type=script&lang=js&"
import style0 from "./HomeExaminationInfo.vue?vue&type=style&index=0&id=5e4fb136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4fb136",
  null
  
)

export default component.exports